import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import Account, {Dashboard} from '../Account/index';
import { willRequireLogin,logout,Login,Register,ResetPassword,ForgotPassword } from '../Auth/index';
import BreadCrumb from '../Common/BreadCrumb';
import VisitorRoute from '../Routes/routesTypes/VisitorRouter';

const PageWrapper = (props) => {
  const { wrapper = 'page-wrapper' } = props;
  return (
    <div>
      {props.banner}
      <BreadCrumb {...props}/>
      <div className='mb-6'/>
        <Dashboard {...props}/>
    </div>
  );
};

const AccountRoutes = (
    <Route label="Account" path="account">
        <Route component={Account}>
            <IndexRedirect to='/account/dashboard/order' />
            <Route path="forgotpassword" component={ForgotPassword}/>
            <Route
              helmet={{
                title: 'Log In',
                metaDescription: 'Create or Sign Into Your Account at {storeName} {guaranteeSlogan}'
              }}
              path="login" component={VisitorRoute(Login)}/>
            <Route path="register" component={VisitorRoute(Register)}/>
         </Route>
        <Route path="resetpassword" component={ResetPassword}/>

        <Route label='Dashboard' path="dashboard" component={willRequireLogin(PageWrapper)}>
          <IndexRedirect to='order' />
          <Route label='Info' path="info" module='info'/>
          <Route label='My Projects' path="project" module='project'/>
          <Route label='My Orders'
            helmet={{
              title: 'Track Order',
              metaDescription: 'We\'ll make sure your book gets to you. {guaranteeSlogan}'
            }}
            path="order" module='order'/>
          <Route label='My Vouchers' path="voucher" module='voucher'/>
          <Route label='My Photobook Pass' path="pass" module='pass'/>
          <Route label='My Credits' path="credit" module='credit'/>
          <Route label='Account Information' path="personal" module='personal'/>
          <Route label='Address Book' path="address" module='address'/>
          <Route label='EPhotobook' path="ephotobook" module='ephotobook'/>
          <Route label='Remind Me' path="remind-me" module='remind-me'/>
        </Route>
        <Route
          path='logout'
          id='logOutMenuItem'
          onEnter={() => {logout()}}
        />
    </Route>
);

export default AccountRoutes;



// WEBPACK FOOTER //
// ./src/Routes/Account.js